import { Builder } from '@builder.io/sdk';
import { IconNames } from '../Icon/Icon';
import { ProductCards } from './ProductCards';
import { BuilderInputOptions } from '@/types/builder';

const ProductCardsConfig = {
  name: 'ProductCards',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'products',
      type: 'list',
      required: true,
      min: 3,
      max: 9,
      subFields: [
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'icon',
          type: 'enum',
          defaultValue: IconNames[0],
          enum: IconNames.map((n) => ({
            label: n,
            value: n,
          })),
        },
        {
          name: 'body',
          type: 'richText',
          onChange: (options: BuilderInputOptions) => {
            const body =
              typeof options.get('body') === 'string' ? String(options.get('body')).replace(/(<([^>]+)>)/gi, '') : '';

            if (body.length > 150) {
              alert('You have exceeded the character limit');
            }
          },
        },
        {
          name: 'buttonText',
          type: 'string',
        },
        {
          name: 'buttonLink',
          type: 'string',
        },
      ],
    },
  ],
};

Builder.registerComponent(ProductCards, ProductCardsConfig);
